<video class="video-player" #videoPlayer preload="auto" controls (error)="handleVideoError($event)">
  <source src="" type="video/mp4">
  Tu navegador no soporta la etiqueta de video.
</video>
